/**
 * @flow
 * @format
 */

import _FieldRadioGroup from './FieldRadioGroup';

export default _FieldRadioGroup;



// WEBPACK FOOTER //
// ./src/components/FieldRadioGroup/index.js